/**
 * شرایط استفاده و حریم خصوصی — متن از `@/core/legal/terms` می‌آد، یعنی دقیقاً
 * همون سندی که اپِ موبایل نشون می‌ده. اگه قرار به تغییر باشه، فقط اونجا.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { getLocale, t, useLocale } from '@/core/lib/i18n';
import { legalDoc } from '@/core/legal/terms';

export function LegalPage() {
  useLocale();
  const doc = legalDoc(getLocale());

  return (
    <div className="wrap prose">
      <Link to="/auth" className="dim">{t('back')}</Link>
      <h1>{doc.title}</h1>
      <p className="dim">{doc.updated}</p>
      <p>{doc.intro}</p>
      {doc.sections.map((s) => (
        <section key={s.n}>
          <h3>{s.n}. {s.title}</h3>
          {s.body.map((line, i) => <p key={i}>{line}</p>)}
        </section>
      ))}
      <p className="dim">{doc.close}</p>
    </div>
  );
}
